import { render, staticRenderFns } from "./UnssignPharmacistDialog.vue?vue&type=template&id=632da4a5&scoped=true&"
import script from "./UnssignPharmacistDialog.vue?vue&type=script&lang=js&"
export * from "./UnssignPharmacistDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632da4a5",
  null
  
)

export default component.exports